import VerticalSlider from '../play/Remote/Klaw/Remote/component/KlawArmPlay/Verticalslider'
import CustomSlider from './CustomSliderPersona'
import styles from './PersonaSetting.module.css'

function VerticalSliderCard({
    sliderValues,
    sliderType,
    sliderLabel,
    handelSliderChange,
    onMouseUpHandel,
}) {
    const setValue = (value) => {
        handelSliderChange(sliderType, value)
    }

    return (
        <div className={styles.sliderCard}>
            <p className={styles.upLimitP}>100</p>
            <div className={styles.largeSliderDiv}>
                <CustomSlider
                    setValue={setValue}
                    value={sliderValues[sliderType]}
                />
            </div>

            <p className={styles.lowLimitP}>0</p>

            <div className={styles.sliderDetails}>
                <p className={styles.sliderValueP}>
                    {100 - parseInt(sliderValues[sliderType])}
                </p>
                <p
                    className={styles.sliderLabelP}
                    // style={{
                    //     display: 'block',
                    //     whiteSpace: 'nowrap',
                    //     marginTop: '20px',
                    // }}
                >
                    {sliderLabel}
                </p>
            </div>
        </div>
    )
}

export default VerticalSliderCard
